import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProductForm from "../../../components/features/products/ProductForm";
import { alertSuccess, alertServerError, alertError } from "../../../helpers/alertError";
import PageLayout from "../../../layouts/PageLayout";
import useCustomParams from "../../../hooks/params/useCustomParams";
import PageContainer from "../../../components/ui/PageContainer";
import { Product, ProductFormData } from "../../../types/Product";
import { useToken } from "../../../hooks/auth/useToken";
import { useProduct } from "../../../hooks/products/useProduct";
import { uploadService } from "../../../services/uploadService";


export default function UpdateProductPage() {
    const navigate = useNavigate();
    const { id } = useCustomParams();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { product, loading, updateProduct } = useProduct({ id: id! });
    const { token } = useToken();

    console.log(product)

    const handleSubmit = async (formData: ProductFormData) => {
        if (!id || !token) {
            alertError("Une erreur s'est produite");
            return;
        }
        setIsSubmitting(true);
        try {
            let imageUrl = product?.imageUrl || '';

            // Si une nouvelle image a été uploadée
            if (formData.image && formData.image.size > 0) {
                const uploaded = await uploadService.uploadMultiple([formData.image], token);
                imageUrl = uploaded[0] || '';
            }

            const submitData = {
                name: formData.name,
                description: formData.description,
                price: formData.price,
                type: formData.type,
                lengths: formData.lengths,
                defaultLength: formData.defaultLength,
                quality: formData.quality,
                density: formData.density,
                texture: formData.texture,
                badge: formData.badge || '',
                imageUrl: imageUrl
            };

            await updateProduct({
                id: id,
                ...submitData
            });
            alertSuccess("Produit modifié avec succès");
            navigate(-1);
        } catch (error: any) {
            console.error(error);
            alertServerError(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (loading) {
        return (
            <PageLayout title="Modifier le produit">
                <div className="flex justify-center py-20">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
                </div>
            </PageLayout>
        );
    }

    if (!product) {
        return (
            <PageLayout title="Modifier le produit">
                <div className="text-center py-20 text-gray-500">Produit non trouvé</div>
            </PageLayout>
        );
    }

    // Transformer les données produit pour le formulaire
    const initialData: Partial<Product> = {
        id: product.id,
        name: product.name,
        price: product.price,
        description: product.description || '',
        type: product.type,
        lengths: product.lengths || ['18 pouces'],
        defaultLength: product.defaultLength || '18 pouces',
        badge: product.badge || '',
        quality: product.quality || 'Raw Virgin Hair 12A',
        density: product.density || '180%',
        texture: product.texture || 'Body Wave',
        imageUrl: product.imageUrl
    };

    return (
        <PageLayout title="Modifier le produit">
            <PageContainer>
                <ProductForm
                    initialData={initialData}
                    onSubmit={handleSubmit}
                    
                    isSubmitting={isSubmitting}
                />
            </PageContainer>
        </PageLayout>
    );
}